import type { DeserializerOptions, SerializerOptions } from 'jsonapi-serializer';
import { Deserializer, Serializer } from 'jsonapi-serializer';

export const JSONApiHeaders = { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json' };

export interface JSONApiResponse<T> {
  data: {
    attributes: T;
    id: string | number
  };
  meta?: {
    'record-count': number;
  };
  //TODO: should this be a generic?
  included?: unknown;
}

export interface JsonBodyRequest<T> {
  data: {
    attributes: T;
    id?: string | number;
    type: string;
  };
}

//TODO: include jsonapi-serializer types
export function deserializeJSONApi<T, K>(response: T, deserializerOpts?: DeserializerOptions): Promise<K> {
  const opts = { ...{ keyForAttribute: 'camelCase' }, ...deserializerOpts } as DeserializerOptions;
  return new Deserializer(opts).deserialize(response);
}

export function serializeJSONApi<T, K>(type: string, body: T, serializerOpts: SerializerOptions = {}): Promise<K> {
  return new Serializer(type, serializerOpts).serialize(body);
}
